export default "__VITE_ASSET__D$QfNdiK__"